import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { giv, callApi, getInlineLoader, isAlphanumeric, resolveOrientation, formatMoney, formatMoneyShorten, formatDate, callGameServerApi } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import { AiFillDollarCircle, AiOutlineSetting } from 'react-icons/ai';
import { MdOutlinePriceChange, MdOutlinePhonelinkRing, MdOutlineMarkEmailUnread, MdOutlineLogout } from 'react-icons/md';
import { RiLockPasswordLine } from 'react-icons/ri';
import { FaAward } from 'react-icons/fa';


export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";

  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ awards, setAwards ] = useState([]);
  const [ totalAwards, setTotalAwards ] = useState(0);

  const getUserAwards = () => {
    return new Promise(async resolve => {
      setLoading(true);
      await callGameServerApi('get-user-awards', { }).then((response) => {
        setLoading(false);
        if(response.status === 1) {
          setAwards(response.userAwards);
          setTotalAwards(response.totalAwards);
          resolve();
        } else {
          appContext.tellError(response.msg);
        }
      })
    });
  }

  const init = async () => {
    appContext.changeOrientation(requiredOrientation);
    await getUserAwards().then(() => {
      setReady(true);
    })
  }

  const claimAward = async (awardId) => {
    if(!loading) {
      let phone = giv("_aw"+awardId+"Phone");
      let password = giv("_aw"+awardId+"Password");

      if(phone.trim().length === 10) {
        if(password.trim().length > 0) {
          setLoading(true);
          await callGameServerApi('claim-award', { awardId, phone, password }).then(async response => {

            if(response.status === 1) {
              await getUserAwards().then(() => {
                setLoading(false);
                appContext.tellMessage('Your request was sent.')
              })
            } else {
              setLoading(false);
              appContext.tellError(response.msg);
            }
          })
        } else {
          appContext.tellError('Invalid password');
        }
      } else {
        appContext.tellError('Invalid phone number');
      }
    } else {
      appContext.tellError('Please wait....');
    }
  }

  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();
    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  if(ready) {
    return (
      <>
        <TopBar title="Your Awards"/>
        <div className="FullPane"  data-support-top-bar={true}>
          <div className="container" style={{ paddingBottom: "40px" }}>
            <div className="row">

              <div className="col-md-12 col-sm-12" style={{ marginTop: "10px" }}>
                <div className="card text-end">
                  <div className="card-body">
                    <p className="font-light text-goldish" style={{ fontSize: "40px" }}>{formatMoney(totalAwards)}</p>
                    <small className="text-muted">Total Awarded amount in Tsh</small>
                  </div>
                </div>
              </div>

              <div className="col-md-12 col-sm-12 mt-4">
                <h6
                  style={{
                    marginTop: "30px",
                    fontSize: "28px"
                  }}
                  className='font-semi-bold'
                >
                  Awards
                </h6>
              </div>

              {
                (awards && awards.length > 0) ?
                awards.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className="col-md-12 col-sm-12"
                      style={{
                        padding: "10px",
                      }}
                    >
                      <div className='card'>
                        <div className='card-body'>
                          
                          <p style={{ fontSize: "25px" }} className="font-light">{formatMoney(item.amount)} Tsh</p>
                          <p className="font-light text-muted">{item.description}</p>
                          <small className="font-light text-goldish form-text">Awarded on: {formatDate(item.dateAwarded)}</small>

                          {
                            (item.status === 'unclaimed') ?
                            <div className="text-start">
                              <small className="font-light text-redish form-text">Not Yet Claimed</small>

                              <div className="row">
                                <div className="col-6">
                                  <div className="form-group text-start">
                                    <label style={{ fontSize: "12px" }}>Your Phone Number</label>
                                    <input maxLength={10} placeholder="07XXXXXXXX" id={"_aw"+item.id+"Phone"} className="form-control" type="text"/>
                                  </div>
                                </div>

                                <div className="col-6">
                                  <div className="form-group text-start">
                                    <label style={{ fontSize: "12px" }}>Soldrax Password</label>
                                    <input id={"_aw"+item.id+"Password"} className="form-control" type="password"/>
                                  </div>
                                </div>

                                <div className="col-12">
                                  <small className="form-text">Money will be sent to this number, please double-check it to avoid mistakes</small>
                                  <button 
                                    onClick={() => {
                                      appContext.activateDialog({
                                        message: "Are you sure you want to claim this award using the provided phone number?",
                                        onConfirm: () => claimAward(item.id),
                                      })
                                    }} 
                                    className="btn bg-goldish"
                                  >
                                    CLAIM NOW
                                  </button>

                                </div>

                              </div>
                            </div>
                            :
                            (item.status === 'sent') ?
                            <div className="text-start">
                              <small className="font-bold">
                                Sent to {item.beneficiaryPhone} on {formatDate(item.dateSent)}.
                              </small>
                            </div>
                            :
                            <div className="text-start">
                              <small className="font-light text-whitish form-text">
                                You claimed this award on {formatDate(item.dateClaimed)}.
                                It takes 3 working days to deliver your award, please contact us if it takes any longer than that
                              </small>
                            </div>
                          }
                          
                        </div>
                      </div>

                      
                    </div>
                  )
                }):
                <div className="col-md-12 col-sm-12" style={{ marginTop: "30px" }}>
                  <small className="font-light text-redish">No awards were found. Participate in leagues to win awards</small>
                </div>
              }

            </div>
          </div>
        </div>
      </>
    )
  } else {
    return (
      <div className="FullPane">
        {getInlineLoader()}
      </div>
    )
  }
}
